import $ from 'cash-dom';
import { matchBelowLg } from '../media';

/**
 * This module helps adjusting the layout of the mobile funds diagram
 */
export default class FundsModule {

    static name = 'funds';

    constructor(node) {
        
        this.node = $(node);
        this.container = this.node.find('.funds-js');
        this.box = this.container.find('article.body-funds:nth-child(2)');

        if(!this.box.length) return;

        document.fonts.ready.then(() => {
            $(window).on('resize', this.handleResize);
            this.handleResize();
        });
    }

    handleResize = () => {
        if(matchBelowLg.matches) {

            // in the mobile design, there are three content boxes, 
            // the "banners" on left and right are top/bottom aligned with the 2nd box

            const boxTop = this.box[0].offsetTop;
            const boxHeight = this.box[0].offsetHeight;
            const containerHeight = this.container[0].offsetHeight;

            const leftHeight = boxTop + boxHeight;
            const rightHeight = containerHeight - boxTop;

            this.node.css('--left-height', `${leftHeight}px`);
            this.node.css('--right-height', `${rightHeight}px`);

        }
    }
}